import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  PerspectivesSection,
  SectionTitle,
  SectionSubtitle,
  AreasContainer,
  AreaItem,
  AreaNumber,
  AreaTitle,
  AreaDescription
} from './styles';

const Perspectives: React.FC = () => {
  const { language } = useLanguage();
  const areas = [
    {
      number: '01',
      title: 'Desenvolvimento de Software',
      description: 'Criação de aplicações web e mobile com foco em experiência do usuário e performance.'
    },
    {
      number: '02',
      title: 'Inteligência Artificial',
      description: 'Desenvolvimento de soluções baseadas em IA para automação e otimização de processos.'
    },
    {
      number: '03',
      title: 'Realidade Virtual e Aumentada',
      description: 'Criação de experiências imersivas para diversos setores, do entretenimento à educação.'
    },
    {
      number: '04',
      title: 'Internet das Coisas (IoT)',
      description: 'Desenvolvimento de ecossistemas conectados para cidades inteligentes e indústria 4.0.'
    },
    {
      number: '05',
      title: 'Blockchain e Criptomoedas',
      description: 'Implementação de soluções descentralizadas para segurança e transparência.'
    },
    {
      number: '06',
      title: 'Cibersegurança',
      description: 'Proteção de dados e sistemas contra ameaças digitais com tecnologias avançadas.'
    },
    {
      number: '07',
      title: 'Cloud Computing',
      description: 'Desenvolvimento e migração de soluções para ambientes em nuvem escaláveis.'
    },
    {
      number: '08',
      title: 'Big Data e Analytics',
      description: 'Análise e visualização de grandes volumes de dados para insights estratégicos.'
    },
    {
      number: '09',
      title: 'Design de Experiência (UX/UI)',
      description: 'Criação de interfaces intuitivas e acessíveis centradas no usuário.'
    },
    {
      number: '10',
      title: 'Sustentabilidade Tecnológica',
      description: 'Desenvolvimento de soluções eco-friendly e energeticamente eficientes.'
    }
  ];

  return (
    <PerspectivesSection>
      <div className="container">
        <SectionTitle>{language === 'pt' ? 'NOSSOS CLIENTES' : 'OUR CLIENTS'}</SectionTitle>
        <SectionSubtitle>
          {language === 'pt' 
            ? 'Atendemos diversos setores com soluções tecnológicas personalizadas'
            : 'We serve various sectors with customized technological solutions'}
        </SectionSubtitle>
        
        <AreasContainer>
          <AreaItem>
            <AreaNumber>01</AreaNumber>
            <div>
              <AreaTitle>{language === 'pt' ? 'Governo' : 'Government'}</AreaTitle>
              <AreaDescription>
                {language === 'pt' 
                  ? 'Desenvolvemos soluções para órgãos governamentais que aumentam a eficiência, transparência e segurança na gestão pública e nos serviços ao cidadão.'
                  : 'We develop solutions for government agencies that increase efficiency, transparency, and security in public management and citizen services.'}
              </AreaDescription>
            </div>
          </AreaItem>

          <AreaItem>
            <AreaNumber>02</AreaNumber>
            <div>
              <AreaTitle>{language === 'pt' ? 'Saúde' : 'Healthcare'}</AreaTitle>
              <AreaDescription>
                {language === 'pt' 
                  ? 'Criamos sistemas de gestão clínica, telemedicina e análise de dados que melhoram o atendimento ao paciente e otimizam processos hospitalares.'
                  : 'We create clinical management systems, telemedicine, and data analysis that improve patient care and optimize hospital processes.'}
              </AreaDescription>
            </div>
          </AreaItem>

          <AreaItem>
            <AreaNumber>03</AreaNumber>
            <div>
              <AreaTitle>{language === 'pt' ? 'Finanças' : 'Finance'}</AreaTitle>
              <AreaDescription>
                {language === 'pt' 
                  ? 'Implementamos soluções seguras para instituições financeiras, incluindo sistemas de pagamento, análise de risco e prevenção de fraudes com tecnologia avançada.'
                  : 'We implement secure solutions for financial institutions, including payment systems, risk analysis, and fraud prevention with advanced technology.'}
              </AreaDescription>
            </div>
          </AreaItem>

          <AreaItem>
            <AreaNumber>04</AreaNumber>
            <div>
              <AreaTitle>{language === 'pt' ? 'Educação' : 'Education'}</AreaTitle>
              <AreaDescription>
                {language === 'pt' 
                  ? 'Desenvolvemos plataformas de ensino digital, sistemas de gestão acadêmica e ferramentas de aprendizado interativo para instituições educacionais.'
                  : 'We develop digital learning platforms, academic management systems, and interactive learning tools for educational institutions.'}
              </AreaDescription>
            </div>
          </AreaItem>

          <AreaItem>
            <AreaNumber>05</AreaNumber>
            <div>
              <AreaTitle>{language === 'pt' ? 'Varejo' : 'Retail'}</AreaTitle>
              <AreaDescription>
                {language === 'pt' 
                  ? 'Criamos soluções de e-commerce, gestão de estoque e experiência do cliente que ajudam empresas de varejo a se destacarem no mercado digital.'
                  : 'We create e-commerce solutions, inventory management, and customer experience that help retail companies stand out in the digital market.'}
              </AreaDescription>
            </div>
          </AreaItem>

          <AreaItem>
            <AreaNumber>06</AreaNumber>
            <div>
              <AreaTitle>{language === 'pt' ? 'Indústria' : 'Industry'}</AreaTitle>
              <AreaDescription>
                {language === 'pt' 
                  ? 'Implementamos sistemas de automação, monitoramento e análise de dados que aumentam a eficiência e reduzem custos em ambientes industriais.'
                  : 'We implement automation systems, monitoring, and data analysis that increase efficiency and reduce costs in industrial environments.'}
              </AreaDescription>
            </div>
          </AreaItem>
        </AreasContainer>
      </div>
    </PerspectivesSection>
  );
};

export default Perspectives;